import React from 'react';
import { cn } from '@/lib/utils';
import { HtmlContent } from '@/components/ui/html-content';
import { hasValidHTMLContent } from '@/utils/html-content';
import { Image } from './Image';
import { useReportI18n } from '@/pages/reports/i18n';

interface BusinessCardProps {
  sectionTitle?: string;
  img?: string;
  title: string;
  titleLink?: string;
  complementaryText?: string;
  className?: string;
}

export const BusinessCard: React.FC<BusinessCardProps> = ({
  sectionTitle,
  img,
  title,
  titleLink,
  complementaryText,
  className,
}) => {
  const { t } = useReportI18n();
  const heading = (sectionTitle ?? '').trim() || t('business.title');
  const newsTitle = (title ?? '').trim();
  const showComplementaryText = Boolean(
    complementaryText && hasValidHTMLContent(complementaryText)
  );

  return (
    <section className={cn('w-full bg-white', className)}>
      <div className="container mx-auto">
        <div className="w-full max-w-[500px] mx-auto py-10 md:py-14 px-4 md:px-0">
          <div className="flex flex-col gap-6 items-start text-left">
            <h2 className="font-['Times_New_Roman'] font-normal text-[clamp(3rem,14vw,4.9rem)] leading-[1.05] tracking-[-0.025em] text-black text-balance break-words">
              {heading}
            </h2>
            {img && (
              <div className="flex justify-start">
                <Image
                  src={img}
                  alt=""
                  className="w-[170px] h-[170px] object-contain"
                />
              </div>
            )}
            <div className="flex flex-col gap-4">
              {newsTitle && (
                <div className="font-['Times_New_Roman'] text-2xl md:text-3xl text-black leading-tight">
                  {titleLink ? (
                    <a
                      href={titleLink}
                      target="_blank"
                      rel="noopener noreferrer"
                      className="underline"
                    >
                      {newsTitle}
                    </a>
                  ) : (
                    newsTitle
                  )}
                </div>
              )}
              {showComplementaryText && (
                <HtmlContent
                  html={complementaryText!}
                  className="text-base md:text-lg text-black font-['Times_New_Roman'] font-normal [&_p]:mb-3 [&_p:last-child]:mb-0"
                />
              )}
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};
